import React, { useEffect, useState } from 'react';
import { Button, Font, Modal, TextInput } from 'is24-corecss';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { generatePath } from 'react-router';
import { useIntl } from 'react-intl';
import { TeamMember } from '../../../../models/TeamMember';
import { ACCEPT_INVITATION } from '../../../../pages/AppRoutes';

import styles from './styles.module.css';
import { fetchCurrentInvitation } from '../../../../api/TeamMemberApi';
import { getErrorMessage } from '../../../../common/statusMesssages';
import { baseDomain } from '../../../../common/config';
import { reportViewEvent } from '../../../../tracking/tracking';

type InvitationLinkCopyModalProps = {
  visible: boolean;
  selectedTeamMember: TeamMember | null;
  onClose: () => void;
};

const getInvitationLink = (teamMember: TeamMember | null, invitationId: string) => {
  if (teamMember != null) {
    const invitationUrl = generatePath(ACCEPT_INVITATION, {
      teamMemberId: teamMember.id || null,
      invitationId,
    });
    return `https://myteam.${baseDomain()}${invitationUrl}?showLandingPage=true`;
  }
  return '';
};

const InvitationLinkCopyModal: React.FC<InvitationLinkCopyModalProps> = ({ visible, onClose, selectedTeamMember }: InvitationLinkCopyModalProps) => {
  const [invitationLink, setInvitationLink] = useState<string>('');
  const fetchInvitation = async () => {
    if (selectedTeamMember != null) {
      try {
        const invitation = await fetchCurrentInvitation(selectedTeamMember);
        setInvitationLink(getInvitationLink(selectedTeamMember, invitation.id));
      } catch (e) {
        getErrorMessage(e);
      }
    }
  };
  useEffect(() => {
    if (visible) {
      reportViewEvent({ pageTitle: 'invitation_link' });
      fetchInvitation();
    }
  }, [visible]);

  const intl = useIntl();
  return (
    <Modal visible={visible} onClose={onClose} title={intl.formatMessage({ id: 'teammanagement.table.button.copy.invitation.link' })} width={864}>
      <div data-testid='invitation-sent-modal' className='grid grid-flex'>
        {invitationLink && (
          <div className='one-whole padding-bottom-l grid grid-flex'>
            <div className={styles.inputFieldWrapper}>
              <TextInput disabled data-testid='team-member-invitation-link' id='invitation-link' label='' placeholder='' value={invitationLink} />
            </div>
            <CopyToClipboard text={invitationLink}>
              <Button className={styles.copyButton} appearance='primary' size='small' aria-label='Edit'>
                <span className='is24-icon-link button-icon-margin-right' />
                Kopieren
              </Button>
            </CopyToClipboard>
          </div>
        )}
        <div className='grid-item one-whole align-center grid-align-center'>
          <Font className='padding-bottom-m'>Klicken Sie auf &quot;Kopieren&quot; und teilen Sie den Link mit Ihrem Teammitglied.</Font>
        </div>
        <div className='grid-item one-whole align-center grid-align-center'>
          <Button data-testid='invitation-sent-done-button' appearance='inverted' onClick={onClose}>
            Schließen
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default InvitationLinkCopyModal;
